import React from 'react';
import { Link } from 'react-router-dom';
import sanitizeHtml from 'sanitize-html';
import { ReadMoreButton } from '@yme/molecules/buttons';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { getSanitizeHtml } from '@yme/utils/common';
import { CaptionStyled, ContentStyled, MiddleDot, TitleStyled } from './styled';
export function CardForEventsData({ isFullHeaderVisible = false, link, title, plainTitle, onClickHandler, linkTarget, countLineVisible = 3, description, toRoute, isRightToLeft, labelLink, caption, additionalCaption, isSearchPage = false, }) {
    return (React.createElement(React.Fragment, null,
        caption && (React.createElement(CaptionStyled, { isSearchPage: isSearchPage },
            caption,
            additionalCaption && (React.createElement(React.Fragment, null,
                React.createElement(MiddleDot, null),
                additionalCaption)))),
        title && (React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(TitleStyled, { isSearchPage: isSearchPage, isFullHeaderVisible: isFullHeaderVisible, to: isSearchPage
                    ? link
                    : {
                        pathname: link,
                    }, weight: 500, title: plainTitle || title, isLink: Boolean(link), as: Link, onClick: onClickHandler, target: linkTarget, dangerouslySetInnerHTML: isSearchPage
                    ? {
                        __html: sanitizeHtml(title),
                    }
                    : undefined }, isSearchPage ? null : title))),
        description && (React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(ContentStyled, { isSearchPage: isSearchPage, color: colorCoreBlack300, countLineVisible: countLineVisible, dangerouslySetInnerHTML: {
                    __html: isSearchPage ? sanitizeHtml(description) : getSanitizeHtml(description),
                } }))),
        link && (React.createElement(FlexWrapper, null,
            React.createElement(ReadMoreButton, { toRoute: toRoute, linkTarget: linkTarget, isRightToLeft: isRightToLeft, onClickHandler: onClickHandler, labelLink: labelLink })))));
}
